<template>
	<div class="pdfPage" :class="{ fillPage: fillPage }">
		<div v-if="isBig == 1" id="pdf"></div>

		<div class="pdf_list" v-else-if="isBig == 2">
			<div class="option">
				<button class="prev" @click="prevPage">上一页</button>
				<button class="next" @click="nextPage">下一页</button>
			</div>
			<div class="pageNum">
				<input type="number" :value="current" @input="page_change" />
				/&nbsp;&nbsp;&nbsp;&nbsp;{{ total }}
			</div>
			<div class="position">
				<pdf :page="current" :src="pdfUrl" @progress="loadedRatio = $event" @num-pages="pageTotalNum = $event"></pdf>
			</div>
		</div>

		<div class="load" v-else>请稍后...</div>
	</div>
</template>

<script>
import pdf from 'vue-pdf';
import Pdfh5 from 'pdfh5';
import 'pdfh5/css/pdfh5.css';
import { Toast } from 'vant';
export default {
	name: 'PdfPreview',
	components: {
		pdf
	},
	props: {
		pdfUrl: {
			/* PDF文件链接 */
			typeof: String,
			default: ''
		},
		max: {
			/* 一般情况个别机型大于70页就无法预览 */
			typeof: Number,
			default: 70
		},
		fillPage: {
			/* 容器是否使用100vh占满屏幕 */
			typeof: Boolean,
			default: false
		},
		custom: {
			/* 预留自定义控制，暂无功能 */
			typeof: Boolean,
			default: false
		}
	},
	data() {
		return {
			isBig: 0, //文件页数是否过大：0 等待初始化 1过大 2正常浏览
			backTop: false,
			current: 1,
			total: 1,
			loadedRatio: 0
		};
	},
	created() {
		this.init();
	},
	mounted() {},
	methods: {
		init() {
			let element = pdf.createLoadingTask(this.pdfUrl);
			element.promise
				.then((res) => {
					this.total = res.numPages;
					if (this.total >= this.max) {
						this.isBig = 2; //过大
					} else {
						this.isBig = 1; //正常浏览
						this.$nextTick(() => {
							this.newPdf();
						});
					}
				})
				.catch((err) => {
					console.error(err, ' -------- PDF 加载失败');
				});
		},
		newPdf() {
			// pdfh5实例化时传两个参数：selector选择器，options配置项参数，会返回一个pdfh5实例对象，可以用来操作pdf，监听相关事件
			// pdfh5 = new Pdfh5(selector, options) goto初始到第几页，logo设置每一页pdf上的水印
			this.pdfh5 = new Pdfh5('#pdf', {
				pdfurl: this.pdfUrl,
				goto: 1,
				// lazy: true,
				zoomEnable: false,
				maxZoom: 1,
				// disableRange: true,
				URIenable: true,
				// disableAutoFetch: true,
				renderType: 'canvas'
			});
			// 监听pdf准备开始渲染，此时可以拿到pdf总页数
			this.pdfh5.on('ready', function () {
				console.log('总页数:' + this.totalNum);
			});
			// 监听pdf加载完成事件，加载失败、渲染成功都会触发
			this.pdfh5.on('complete', (status, msg, time) => {
				console.log('状态:' + status + '，信息:' + msg + '，耗时:' + time + '毫秒');
			});
		},
		prevPage() {
			// 上一页
			if (this.current == 1) return Toast('已经在第一页了~~');
			let page = this.current;
			page = page > 1 ? page - 1 : this.total;
			this.current = page;
		},
		nextPage() {
			// 下一页
			if (this.current == this.total) return Toast('没有更多了~~');
			let page = this.current;
			page = page < this.total ? page + 1 : 1;
			this.current = page;
		},
		page_change(e) {
			console.log(e.target.value);
			let value = e.target.value * 1;
			if (e.target.value?.length == 0) return;
			if (value > 0 && value <= this.totalNumber) {
				this.current = value;
			} else {
				Toast('请输入合理区间');
			}
		}
	}
};
</script>

<style lang="less" scoped>
.pdfPage {
	width: 828px;
	height: 100%;
	// overflow-y: auto;
	// overflow-x: hidden;

	&.fillPage {
		height: 100vh;
	}

	.pdf_list {
		width: 100%;
		height: 100%;
		padding-bottom: 15vh;
		position: relative;

		.position {
			width: 100%;
			height: 100%;
			flex: 1;
			& > * {
				width: 100%;
				height: 100%;
				flex: 1;
				display: flex !important;
				align-items: center;
			}
		}

		.option {
			position: absolute;
			bottom: 4vh;
			left: 50%;
			transform: translateX(-50%);
			z-index: 11;

			.prev,
			.next {
				margin: 0 12px;
				height: 60px;
				color: #fff;
				border: none;
				padding: 0 12px;
				font-size: 26px;
			}

			.prev {
				background-color: #008ae6;
			}

			.next {
				background-color: #e60027;
			}
		}

		.pageNum {
			position: absolute;
			bottom: 9vh;
			left: 50%;
			transform: translateX(-50%);
			font-size: 30px;

			input {
				width: 70px;
				text-align: center;
				display: inline-block;
			}
		}
	}

	.load {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateY(-50%) translateX(-50%);
		z-index: 967;
	}
}
</style>
